/** The risk officer's reading as a callout: the header in its tone, the measures past a limit with their cause, and the ways on. Opens the "Risk officer's note" tab of the Drawer (the panel's own one-line status is the StatusStrip). */
import { GxTerm } from "../theme/GxTerm";
import { Link } from "../shell/history";
import type { Callout } from "./planRows";

export function RiskCallout({ callout, onNote, limitsHref }: { readonly callout: Callout; readonly onNote: () => void; readonly limitsHref: string | undefined }) {
  return (
    <div className={`gx-callout gx-callout--${callout.tone} gx-plan-risk`} data-testid="decide.watch" data-state={callout.status.toLowerCase().replace(" ", "")} role="status">
      <b className="gx-plan-risk-h" data-testid="decide.watch.header">{callout.head}</b>
      {callout.line === null ? null : <div className="gx-plan-risk-line" data-testid="decide.watch.closest">{callout.line}</div>}
      {callout.rows.map((r, i) => (
        <div key={`${r.label}${i}`} className="gx-plan-risk-item" data-testid="decide.watch.row">
          <div className="gx-plan-risk-row gx-num">
            <span>{r.kpi === undefined ? r.label : <GxTerm term={r.kpi}>{r.label}</GxTerm>}</span>{r.limit === undefined ? null : <span>{r.at === undefined ? null : <small className="gx-faint" data-testid="decide.watch.at">{r.at}</small>} {r.value === undefined ? null : <b className="gx-plan-crit">{r.value}</b>} <small>limit {r.limit}</small></span>}
          </div>
        </div>
      ))}
      {callout.tone === "good" || callout.tone === "info" ? (callout.more === 0 ? null : <div className="gx-plan-risk-line" data-testid="decide.watch.more">and {callout.more} more in the note</div>) : (
        <div className="gx-plan-risk-links">
          <button type="button" className="gx-linkrow" data-testid="decide.watch.note" onClick={onNote}>Read the risk officer's note</button>
          {limitsHref === undefined ? null : <> {"·"} <Link href={limitsHref}>Edit limits</Link></>}
          {callout.more === 0 ? null : <>{" "}<small className="gx-faint" data-testid="decide.watch.more">and {callout.more} more</small></>}
        </div>
      )}
    </div>
  );
}
